import { ReactElement } from 'react';

import { ThemeEnum } from '../../../../../../../shared/theme/enums/theme.enum';
import localStorageService from '../../../../../services/local-storage/local-storage.service';
import { castTo } from '../../../../../utils/cast-to';
import { logoMap } from './utils/logo-map-def/logo-map-def.util';

export const useLogo = (): ReactElement => {
  const themeName =
    castTo<ThemeEnum>(localStorageService.get('themePalette')) ??
    ThemeEnum.SPARQ;

  return logoMap.get(themeName)!;
};
